import React, {useState, useEffect} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import { IconButton } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import NavLink from '../nav_link/NavLink';

const Refund = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [status, setStatus] = useState("pending");
     const [errorMessage, setErrorMessage] = useState(null);
     const tableHead = ["User", "Order id", "Amount", "Transaction id (Rozorpay)", "Date", ""];
     const selectionItems =  ["Pending", "Approved", "Rejected"];
     const selectionItemKeys = ["pending", "approved", "rejected"];

     const onPageChange = async (e, pageIndex, mStatus) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * pageIndex);
               params.append("limit", 20);
               if(mStatus){
                    params.append("status", mStatus);
               }
               else params.append("status", status);

               const res = await axiosInstance.get('admin/refund-request', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 0);
     }, []);

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Refund Request</h5>
                    </div>
                    <DropdownMenu items={selectionItems} onChange={(value, i)=> {
                              const status = selectionItemKeys[i];
                              setStatus(status);
                              onPageChange(null, 0, status);
                         }}/>
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item currentStatus={status} data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
          </>
     );
}

const Item = (props) => {
     const { _id , userName, mobileNumber, amount, txnId, order, date } = props.data;
     const [showing, setShowing] = useState(true); 

     const onAction = async (status) => {
          setShowing(false);
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               rBody.append("status", status)
               const res = await axiosInstance.patch("admin/refund-request", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
          }
     }

     if(!showing) return null;

     // ["Barber", "Amount", "Account holder name", "Account number", "IFSC code", "Date", ""];

     return(
          <tr>
               <td>{userName + (mobileNumber ? "( " + mobileNumber + " )" : "")}</td>
               <td>{order}</td>
               <td>₹{amount}</td>
               <td>{txnId}</td>
               <td>{date}</td>
               {props.currentStatus == 'pending' ? <td>
                    <button className='item_action_btn' style={{background: '#df1111'}} onClick={()=>onAction('rejected')}>Reject</button>
                    <button className='item_action_btn' style={{background: 'green'}} onClick={()=>onAction('approved')}>Approve</button>
               </td> : null}
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div style={{height: "300px", fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
               {props.message}
          </div>
     );
}

export default Refund;